
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { SystemSettings } from "@tylertech/tyler-api-types";

/**
 * ApiUtilitiesService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ApiUtilitiesService {
    private readonly $apiService = inject(ApiService);
    
    GetGoogleMapsApiKey(): Promise<string> {
        return this.$apiService.sendAuth("IApiUtilitiesService/GetGoogleMapsApiKey");
    }
    UpdateSystemSettingsAsync(settings: SystemSettings): Promise<void> {
        return this.$apiService.sendAuth("IApiUtilitiesService/UpdateSystemSettingsAsync", settings);
    }
}
